import React, { useContext } from "react";
import { hex2rgba } from "../../Helpers/parse";
import { getQueryVariable } from "../../Helpers/QueryString";
import { GlobalContext } from "../../Context/GlobalContext";

const SideMenu = ({ color, navigatePage, payload }) => {
  const pageNameQueryVariable = getQueryVariable("page");
  const {darkMode, toggleDarkMode} = useContext(GlobalContext);
  return (
    <div id="sideMenu" className={darkMode?"dark side-menu":"side-menu"}>
      <div
        style={{
          color:
            pageNameQueryVariable !== "LIVE" &&
            pageNameQueryVariable !== "PLAYLIST" &&
            pageNameQueryVariable !== "ABOUT" &&
            pageNameQueryVariable !== "RECENT"
              ? color
              : "",
          backgroundColor:
            pageNameQueryVariable !== "LIVE" &&
            pageNameQueryVariable !== "PLAYLIST" &&
            pageNameQueryVariable !== "ABOUT" &&
            pageNameQueryVariable !== "RECENT"
              ? color
                ? hex2rgba(color, 0.08)
                : ""
              : "",
        }}
        className={ darkMode?
          "dark side-menu-item ":'side-menu-item' //+
          // (pageNameQueryVariable !== "LIVE" &&
          // pageNameQueryVariable !== "PLAYLIST" &&
          // pageNameQueryVariable !== "ABOUT" &&
          // pageNameQueryVariable !== "RECENT"
          //   ? "-selected"
          //   : "")
        }
        onClick={() => navigatePage("HOME")}
      >
        <i className="fas fa-home fa-2x"></i>
        <div>Home</div>
      </div>

      <div
        style={{
          color: pageNameQueryVariable === "PLAYLIST" ? color : "black",
          backgroundColor:
            pageNameQueryVariable === "PLAYLIST"
              ? color
                ? hex2rgba(color, 0.08)
                : ""
              : "",
        }}
        className={
          darkMode?"dark side-menu-item " + (payload["playlists"]?.length ? "" : "d-none"):"side-menu-item " + (payload["playlists"]?.length ? "" : "d-none") // +
          // (pageNameQueryVariable === "PLAYLIST" ? "-selected" : "")
        }
        onClick={() => navigatePage("PLAYLIST")}
      >
        <i className="far fa-folder-open fa-2x"></i>
        <div>Playlists</div>
      </div>

      <div
        style={{
          color: pageNameQueryVariable === "LIVE" ? color : "black",
          backgroundColor:
            pageNameQueryVariable === "LIVE" && color
              ? hex2rgba(color, 0.08)
              : "",
        }}
        className={
         darkMode? "dark side-menu-item " + (payload["live"].length ? "" : "d-none"):"side-menu-item " + (payload["live"].length ? "" : "d-none")
          // (pageNameQueryVariable === "LIVE" ? "-selected" : "")
        }
        onClick={() => navigatePage("LIVE")}
      >
        <i className="fas fa-broadcast-tower fa-2x"></i>
        <div>Live</div>
      </div>

      <div
        style={{
          color: pageNameQueryVariable === "RECENT" ? color : "",
          backgroundColor:
            pageNameQueryVariable === "RECENT" && color
              ? hex2rgba(color, 0.08)
              : "",
        }}
        className={
          "side-menu-item " + (payload["recent"].length ? "" : "d-none")
          // (pageNameQueryVariable === "RECENT" ? "-selected" : "")
        }
        onClick={() => navigatePage("RECENT")}
      >
        <i className="fas fa-history fa-2x"></i>
        <div>Recent</div>
      </div>
      <div
        style={{
          color: pageNameQueryVariable === "ALL" ? color : "",
          backgroundColor:
            pageNameQueryVariable === "ALL" && color
              ? hex2rgba(color, 0.08)
              : "",
        }}
        className={
          "side-menu-item "
          // (pageNameQueryVariable === "ALL" ? "-selected" : "")
        }
        onClick={() => navigatePage("ALL")}
      >
        <i className="fas fa-film fa-2x"></i>
        <div>All Videos</div>
      </div>
      <span style={{display:'flex', justifyContent:'center'}}>
      <div>
  <input onChange={()=>{ console.log();toggleDarkMode(!darkMode)} } checked={darkMode}  type="checkbox" className="checkbox" id="checkbox"/>
  <label htmlFor="checkbox" className={darkMode?"checkbox-label":"light checkbox-label"}>
  <><i className="fas fa-moon"></i><i className="fas fa-sun"></i></>
    
    <span className="ball"></span>
  </label>
</div>
</span>
    </div>
  );
};

export default SideMenu;
